import React from 'react';
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-dark py-14 sm:py-28 px-4 sm:px-6 relative overflow-hidden" data-id="element-173">
      {/* Background Glows */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-primary/5 rounded-full blur-[100px] pointer-events-none" data-id="element-174"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-175">
        <h2 className="text-3xl sm:text-6xl font-serif font-black text-text-main text-center mb-6 sm:mb-16 tracking-tight" data-id="element-176">
          Offerta Speciale di Lancio
        </h2>

        {/* Featured Card */}
        <div className="bg-white rounded-xl sm:rounded-3xl border border-border-light shadow-[0_10px_40px_rgba(201,137,155,0.1)] px-5 py-7 sm:p-14 flex flex-col relative w-full sm:w-[90%] mx-auto" data-id="element-177">
          <div className="absolute -top-3 sm:-top-5 left-1/2 -translate-x-1/2 bg-primary text-white font-bold text-[10px] sm:text-base px-4 sm:px-8 py-1 sm:py-2.5 rounded-full whitespace-nowrap shadow-[0_4px_15px_rgba(201,137,155,0.3)]" data-id="element-178">
            ⭐ LA SCELTA PIÙ POPOLARE
          </div>

          <div className="space-y-3 sm:space-y-5 mb-6 sm:mb-10 text-sm sm:text-lg mt-4" data-id="element-179">
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-180">
              <span data-id="element-181">Collezione Didattica (6 volumi Elite)</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-182">
                Valore €97
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-183">
              <span data-id="element-184">Registro Valutazione & Schede Cliniche</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-185">
                Valore €57
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-186">
              <span data-id="element-187">Manuale Pilates Dynamic & Piccoli Attrezzi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-188">
                Valore €47
              </span>
            </div>
            <div className="flex justify-between text-text-main font-medium border-b border-border-light pb-2 sm:pb-3" data-id="element-189">
              <span data-id="element-190">6 Bonus Esclusivi</span>
              <span className="text-text-sec line-through ml-2 flex-shrink-0" data-id="element-191">
                Valore €49
              </span>
            </div>
            <div className="flex justify-between text-text-main font-black pt-2 sm:pt-4 text-base sm:text-xl" data-id="element-192">
              <span data-id="element-193">VALORE TOTALE:</span>
              <span className="text-badge-red line-through" data-id="element-194">€250</span>
            </div>
          </div>

          {/* Price reveal */}
          <div className="text-center mb-4 sm:mb-8 bg-bg-main border border-border-light py-4 sm:py-8 rounded-lg sm:rounded-2xl relative overflow-hidden" data-id="element-195">
            <p className="text-primary font-bold mb-1 sm:mb-2 text-xs sm:text-base" data-id="element-196">
              PREZZO DI OGGI (Sconto Lancio):
            </p>
            <div className="text-text-main font-serif font-black text-4xl sm:text-7xl tracking-tighter" data-id="element-197">
              € 19.90
            </div>
            <div className="text-text-sec text-[10px] sm:text-sm font-medium mt-2" data-id="element-198">
              (Pagamento unico - Accesso a vita)
            </div>
          </div>

          <span className="inline-flex items-center justify-center gap-1.5 text-primary font-bold text-[10px] sm:text-sm bg-primary/10 px-3 py-1 sm:px-4 sm:py-1.5 rounded-full border border-primary/20 mx-auto mb-4 sm:mb-6" data-id="element-199">
            ⏰ Prezzo promozionale — aumenterà a breve
          </span>

          <a href="https://italia.edulabs.online/cart/43322157400182:1" onClick={() => {
          const w = window as any;
          if (w.fbq) {
            w.fbq('track', 'AddToCart', {
              content_name: 'Pilates Elite Bundle',
              content_type: 'product',
              value: 19.9,
              currency: 'EUR'
            });
          }
        }} className="btn-primary-pulse block w-full text-center bg-cta-green text-white font-black text-base sm:text-xl py-4 sm:py-6 rounded-xl sm:rounded-2xl hover:bg-cta-green-hover transition-all shadow-[0_8px_25px_rgba(16,185,129,0.25)] mb-3 sm:mb-6" data-id="element-200">
            👉 SÌ! VOGLIO IL KIT COMPLETO
          </a>

          <p className="text-center text-text-sec text-[10px] sm:text-sm font-medium flex items-center justify-center gap-1.5 sm:gap-3 flex-wrap" data-id="element-201">
            <span data-id="element-202">💳 Pagamento sicuro</span>
            <span data-id="element-203">•</span>
            <span data-id="element-204">⚡ Accesso immediato</span>
            <span data-id="element-205">•</span>
            <span data-id="element-206">🛡️ Garanzia 14 Giorni</span>
          </p>
        </div>
      </div>
    </section>;
}